// extracted by mini-css-extract-plugin
module.exports = {"blogright":"Blogright_blogright__YjXpD","blog_sponser":"Blogright_blog_sponser__1uvOt","blog_allicon":"Blogright_blog_allicon__1U3_q","blog_icons":"Blogright_blog_icons__3hHAw"};